define('views/pages/ProductPageView',['underscore', 'jquery', 'backbone', 'router', 'app', 'PageView','TagCommander','WidgetCollectionView',
    'views/blocks/ProductSidedishView',
    'views/blocks/ProductSidedishDefaultView',
    'views/blocks/ProductSidedishGroupedListView',
    'views/blocks/ProductSidedishCustomBox42View',
    'views/blocks/CustomBox42TutorialView',
    'views/blocks/ProductBoostModalView',
    'BtnSwitchView',
    'template!product',
    'template!blocks/product/nutritional-table',
    'template!blocks/product/ingredient-list',
    'sprintf',
    'formatPrice'
]


, function (_, $, Backbone, router, app, PageView, TagCommander, WidgetCollectionView,
        ProductSidedishView,
        ProductSidedishDefaultView,
        ProductSidedishGroupedListView,
        ProductSidedishCustomBox42View,
        CustomBox42TutorialView,
        ProductBoostModalView,
        BtnSwitchView,
        templateProduct,
        nutritionalTableTemplate,
        ingredientListTemplate,
        sprintf,
        formatPrice)
{

    var view,
        product,
        id_product,
        voucher_free_product,
        canBoost,
        initialSerializedSelection,
        sidedishes,
        sidedishesViews,
        cartProduct,
        isCartProduct,
        slideCount,
        slideIndex,
        slideStart,
        isCustomBox42,
        isMenu,
        customBox42Tutorial,
        productBoost,
        closeStateAddToCart = false;

    function banSidedishAlert(){
        app.banNotice(app.t('Vous devez sélectionner un produit', 'Product'));
    }

    function isIframe() {
        var params = new URLSearchParams(location.search);
        return params.get('i') === '1';
    }

    var ProductPageView = PageView.extend({

        pageName: 'ProductPage',
        displayAsModal: true,

        events: {
            'click .btn-close': 'close',
            'click .preorder': 'preorder',
            'click .add-to-cart': 'addToCart',
            'click .product-nav button': 'navClick',
            'click .product-cta button.next, .product-cta button.no-thanks': 'nextSlide',
            'click .product-cta button.confirm': 'addMenuToCart',
            'click .page-product--illus__thumb': 'displayPicture',
        },
        initialize: function (options) {

            view = this;
            closeStateAddToCart = false;

            // PageView constructor heritage
            PageView.prototype.initialize.apply(view, arguments);
            //
            //
            //
            //
            if (options.id_product) {
                id_product = options.id_product;
            } else {
                id_product = view.$('.page-product').data('id');
            }
            voucher_free_product = options.voucher_free_product || false;

            product = app.getProduct(id_product);
            if(!product){
                app.alert();
                return;
            }
            isMenu = product.isMenu();

            if (options.cartProduct) {
                cartProduct = options.cartProduct;
                sidedishes = cartProduct.getSidedishes();
                initialSerializedSelection = sidedishes.getSerializedSelection();
                isCartProduct = true;
            }else{
                sidedishes = product.resetSidedishes();
                isCartProduct = false;
            }

            // est-ce qu'on peut afficher la modal de boost ?
            canBoost = !isCartProduct && !voucher_free_product;

            // nombre d'étape de la fiche produit
            slideCount = isMenu ? sidedishes.sizeRoot() + 1  : 1;

            // Boost produit
            var presetIndex = sidedishes.presetIndex,
                presetSidedish = presetIndex!==false ? sidedishes.at(presetIndex) : false;
            if(presetSidedish && !presetSidedish.isRoot()){
                // gestion des cross selling groupés
                sidedishes.eachRoot(function(rootSidedish,rootIndex){
                    if(presetSidedish.get('id_parent') === rootSidedish.id){
                        presetIndex = rootIndex;
                    }
                })
            }
            if(!isCartProduct && (presetIndex !== false)){
                presetIndex += 1; // en cas de boost, on passe à l'étape suivante automatiquement
                if(product.get('useProductMapping')){
                    presetIndex += 1; // si il y a un mapping produit
                }
                if(presetIndex>slideCount){
                    presetIndex = slideCount-1;
                }
            }else{
                presetIndex = presetIndex || 0;
            }

            isCustomBox42 = view.isCustomBox42();
            slideIndex = (isMenu && (isCartProduct || voucher_free_product) ? 1 : 0) + presetIndex;
            slideStart = isCustomBox42 ? 0 : 1;
            productBoost = product.getProductBoost();
            //
            if (isCustomBox42) {
                slideCount -= 1;
                slideIndex = 0;
            }
            view.templateProduct = templateProduct;

            var cart = app.getCart();
            view.listenTo(cart, 'changeContext', view.render);
            //
            if(!product.isSync()){
                view.listenTo(product,'sync',view.onSyncProduct);
                product.fetch();
            }
            if (product.getTemplate())
            {
                view.templateProduct = product.getTemplate();

            }
            if(isCustomBox42 && !!sidedishes.at(0).get('tutorial') && !cartProduct && app.isMobile()){
                view.displayTutorial();
            }
            view.render();

        },
        initialRender:function(){
            //
            // affiche la modal d'autocomplete Address si on est sur un pays où c'est configuré ainsi
            if(product && product.hasContextualData() && app.isDeliveryOptionsRequired()){
                var cart = app.getCart(), view = this;
                if(!cart.validateDeliveryOptions()){
                    cart.requireDeliveryOptions('all',true,$.proxy(view.render,view));
                }
            }
        },
        render: function () {
            view.$el.html(view.templateProduct({
                product:product,
                sidedishes:sidedishes,
                isMenu:isMenu,
                isCartProduct:isCartProduct,
                isEditable:!isCartProduct,
                cartProduct:cartProduct,
                voucher_free_product:voucher_free_product,
                cart:app.getCart(),
                isLogged:app.getCustomer().isLogged(),
                firstSidedish: view.getFirstSidedish(),
                isCustomBox42: isCustomBox42,
            }));

            view.$('.slide-'+slideIndex+', .product-nav button:eq('+slideIndex+')').addClass('active');

            // Sidedish Views
            sidedishesViews = [];
            view.$('.slide--sidedish').each(function(index,el){
               var sidedish = sidedishes.atRoot(index),
                   sidedishView,
                   sidedishViewOptions = {
                        el:el,
                        sidedish:sidedish,
                    };
                if (sidedish) {
                    switch(sidedish.get('template')){
                        // gère le mode "groupe de sidedish en list " du projet BYOP
                        case 'grouped_list':
                            sidedishView = new ProductSidedishGroupedListView(sidedishViewOptions);
                            break;
                        // gère le mode "par défaut" classique, ainsi que la VOD (qui marchait également avec des checkbox)
                        case 'custom_box_42':
                            sidedishView = new ProductSidedishCustomBox42View(sidedishViewOptions);
                            break;
                        default :
                            sidedishView = new ProductSidedishDefaultView(sidedishViewOptions);
                            break;
                    }
                }
               view.listenTo(sidedishView,'change',view.onUpdateChildView);
               sidedishesViews.push(sidedishView);
               view.attachView(sidedishView);
            });

            var widgetFooterView = view.attachView(new WidgetCollectionView('product_page_footer',{id_product:product.id}));
            view.$('.page-product-footer-widgets').append(widgetFooterView.$el);

            BtnSwitchView.initializeBtnSwitchOfView(view);

            view.updateBottomNav();

            // Execute last
            setTimeout(function() {
                view.updateButtonLabels();
            })

            view.delegateEvents();
        },
        displayTutorial:function(){
            if(customBox42Tutorial) return; // on affiche la modal qu'une seule fois
            setTimeout(function(){
                customBox42Tutorial = new CustomBox42TutorialView();
                app.displayModal(customBox42Tutorial);
            },1000);
        },
        onUpdateChildView:function(){
            var view = this;
            view.updateBottomNav();
            view.updateButtonLabels();
        },
        displayPicture:function(e){
            var index = $(e.currentTarget).index(),
                _ACTIVE_CLASS_ = 'active',
                eqSelector = ':eq('+index+')',
                pictures = view.$('.page-product--illus__thumb'),
                thumbs = view.$('.page-product--illus__wrapper');
            thumbs.not(eqSelector).removeClass(_ACTIVE_CLASS_);
            thumbs.eq(index).addClass(_ACTIVE_CLASS_);
            pictures.not(eqSelector).removeClass(_ACTIVE_CLASS_);
            pictures.eq(index).addClass(_ACTIVE_CLASS_);
        },
        close: function ()
        {
            if (isIframe()){
                parent.postMessage({
                    event: "close",
                    url: "",
                  }, "*")
            } else {
                // TODO gérer une redirection à la fermeture d'une popin
                // plutot qu'un transfert de ref
                view.product = product;
            view.trigger('close', view, closeStateAddToCart);
                delete view.product;
            }
        },
        addToCart: function (e) {
            view.listenAndAddToCart(false);
            return false;
        },
        preorder: function(e){
            function toggleLoading(state){
                view.$('.preorder').toggleClass('loading',state).attr('disabled',state);
            }
            toggleLoading(true);
            app.getCart().preorder(product.id,false,function(success){
                toggleLoading(false);
                if(success && !product.isMenu()){
                    // ferme la fenetre si l'ajout est direct
                    closeStateAddToCart = true;
                    view.close();
                }
            });
        },
        listenAndAddToCart:function(sidedishesSelected,ignoreBoost){

            if(canBoost && ignoreBoost!==true && productBoost && productBoost.requireProductBoost()){
                var productBoostModalView = new ProductBoostModalView(productBoost,sidedishesSelected);
                app.displayModal(productBoostModalView);
                view.listenToOnce(productBoostModalView,'cancel',function(){
                    view.listenAndAddToCart(sidedishesSelected,true);
                });
                return false;
            }

            view.$('.product-header .add-to-cart, .product-header .confirm').addClass('loading').prop("disabled", true);

            TagCommander.tc_ev_gl(view.$('.add-to-cart').get(0),'product_add',{product:product});

            if(voucher_free_product){
                view.trigger('selectFreeProductSidedishes',sidedishesSelected);
                return;
            }
            var cart = app.getCart();
            // écoute l'ajout au panier
            view.listenToOnce(cart.getProducts(), 'add update', view.onAddProduct);
            //
            function onFail(err){
                var message;
                if(!!err && !!err.responseJSON && (message = err.responseJSON.error)){
                    app.alert(message);
                }
            }
            //
            // ajoute le loader
            //
            if(!sidedishesSelected){
                // cas basique d'ajout au panier
                cart.addProduct(product.id, 1).fail(onFail);
            }else if(isCartProduct){
                // cas mise à jour d'une "formule"
                var newSelection = sidedishes.getSerializedSelection();
                if(newSelection !== initialSerializedSelection){
                    cart.updateProductSidedish(cartProduct.id,sidedishesSelected);
                }else{
                    closeStateAddToCart = true;
                    view.close();
                }
            }else{
                // cas ajout d'une "formule"
                cart.addProduct(id_product,1,{sidedish:sidedishesSelected}).fail(onFail);
            }
        },
        startPageTagCommander:function(options){
            product && TagCommander.LoadPage('product',{id_product:product.id});
        },
        navClick: function (e)
        {
            var targetIndex = parseInt($(e.currentTarget).index());
            view.displaySlide(targetIndex);
        },
        nextSlide: function ()
        {
            if (slideIndex < slideCount) {
                view.displaySlide(slideIndex + 1,true);
            }
        },
        displaySlide: function (index,validate) {
            var slidesEl = view.$('.slide'),
                newSlide = view.$('.slide-' + index);

            if(validate && !view.validateSlide(slideIndex, true)){
                // si on essaie d'aller à l'étape suivante et qu'on a oublié de sélectionné un produit obligatoire
                return;
            }
            if(canBoost && validate && productBoost && productBoost.requireProductBoost(sidedishes.atRoot(index-slideStart))){
                var productBoostModalView = new ProductBoostModalView(productBoost,false);
                app.displayModal(productBoostModalView);
                view.listenToOnce(productBoostModalView,'cancel',function(){
                    slideTo();
                });
                return;
            }
            function slideTo(){
                slideIndex = index;
                view.$('.product-nav button').removeClass('active').eq(index).addClass('active');
                slidesEl.removeClass('active');
                newSlide.addClass('active');
                view.updateBottomNav();
                view.updateButtonLabels();
                app.scrollTop(0);
            }
            slideTo();
        },
        updateButtonLabels:function(){
            //
            // met à jour les labels personnalisés des boutons
            //
            var buttonOk = false,
                buttonCancel = false,
                buttonCartProduct = false,
                sidedish;


            if(slideIndex>=slideStart){
                sidedish = sidedishes.atRoot(slideIndex-slideStart);
                if(sidedish){
                    buttonOk = sidedish.getButtonOk();
                    buttonCancel = sidedish.getButtonCancel();
                }
            }

            // les labels personnalisés ne sont valable que pour l'ajout d'un produit
            var price = product.getPrice('ttc', true);
            sidedishes.each(function(sidedish){
                price += sidedish.getSelectionPrice();
            });

            if(isCartProduct) {
                buttonOk = app.t('Modifier %s', 'Product')
                buttonCartProduct = sprintf.vsprintf(buttonOk, formatPrice(price));
            }

            if (buttonOk) {
                buttonOk = sprintf.vsprintf(buttonOk, formatPrice(price));
            }

            view.$('.product-cta button').each(function(){
                var btn = $(this);
                if(btn.is('.no-thanks,.confirm,.next')){
                    var data_attr = 'data-label',
                        data_attr_default = 'data-default',
                        span = btn.find('>span'),
                        defaultText = span.text() || span.data(data_attr_default),
                        label;

                    if (buttonCartProduct) {
                        label = buttonCartProduct;
                    } else {
                        label = btn.is('.no-thanks') ? buttonCancel : buttonOk;
                    }

                    span.text('').attr(data_attr_default,defaultText);
                    if(label){
                        span.attr(data_attr,label);
                    }else{
                        span.removeAttr(data_attr);
                    }
                }
            });
        },
        validateSlide: function(index, warn, validateEmptiness){
            var sidedishView = sidedishesViews[index-slideStart], validate = true;
            if(!sidedishView){
                // noop validate !
            }else if(validateEmptiness){
                validate = !sidedishView.getEmptiness();
            }else {
                if (index >= slideStart) {
                    validate = sidedishView.validate();
                }
                if (!validate && !!warn) sidedishView.warn();
            }
            return validate;
        },
        updateBottomNav: function(){
            var sidedish = sidedishes.atRoot(slideIndex -1),
                isRequired = sidedish && sidedish.isRequired(),
                validate = view.validateSlide(slideIndex),
                isSingleStepPage = slideCount === 1,
                isFirstStep = slideIndex === 0,
                isLastStep = slideIndex === slideCount -1,
                isProgressStep = !isLastStep && !isFirstStep,
                isSelected = view.validateSlide(slideIndex,false,true);

            view.$('.product-cta button').each(function (i) {
                var button = $(this),
                    disabled = false,
                    visible = false,
                    isConfirm = button.is('.confirm,.add-to-cart'),
                    isNext = button.is('.next'),
                    isNoThanks = button.is('.no-thanks');
                if(button.is('.preorder')){
                    visible = true;
                }else if(isSingleStepPage || isLastStep){
                    visible = isConfirm;
                    disabled = !validate;
                }else if(isFirstStep || isProgressStep){
                    visible = isSelected ? isNext : isNoThanks;
                    disabled = !validate;
                }
                if(isNoThanks){
                    button.text(isRequired ? app.t("Valider","Product") : app.t("Non merci","Product") );
                }
                button.toggleClass('visible',visible);
                button.toggleClass('disabled',disabled);

            });

        },
        onAddProduct: function () {
            closeStateAddToCart = true;
            view.close();
        },
        addMenuToCart:function(e){
            e.preventDefault();
            var sidedishesSelected = {},
                firstInvalidStep = -1;


            // on valide toutes les étapes, et on obtient leurs selections
            sidedishes.eachRoot(function(sidedish, index){
                if(firstInvalidStep>=0) return; // on s'arrète dès que c'est invalide.
                var validation = sidedish.validateSelection();
                if(!validation && firstInvalidStep<0){
                    firstInvalidStep = index;
                }else{
                    var children = sidedish.getChildren();
                    if(children.size()>0){
                        children.each(function(sidedishChild){
                            sidedishesSelected[sidedishChild.id] = sidedishChild.getSimplifiedSelection();
                        })
                    }else{
                        sidedishesSelected[sidedish.id] = sidedish.getSimplifiedSelection();
                    }
                }
            });
            //
            if(firstInvalidStep>=0){ // si une étape est invalide on revient sur la première
                view.displaySlide(firstInvalidStep + slideStart, true);
                return;
            }
            view.listenAndAddToCart(sidedishesSelected);
            return false;
        },
        onSyncProduct:function(product){
            view.$('.table-nutrition').html(nutritionalTableTemplate(product));
        },
        initialMetaTitle:function(){
            if(product) document.title = product.get('title_seo') || product.getTitle();
        },
        getFirstSidedish: function() {
            return sidedishes.models[0]
        },
        isCustomBox42: function() {
            var first=this.getFirstSidedish();
            return (first && first.get('template') === 'custom_box_42')
        },
        isCustomBox42Menu: function() {
            var result = false
            if (this.isCustomBox42()) {
                sidedishes.each(function(sidedish) {
                    if (sidedish.get('template') !== 'custom_box_42') {
                        result = true
                    }
                })
            } else {
                result = false
            }
            return result
        }
    });

    return ProductPageView;

});
